var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_270_5359",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
          },
        },
        [_c("rect", { attrs: { width: "20", height: "20", fill: "#D9D9D9" } })]
      ),
      _vm._v(" "),
      _c("g", { attrs: { mask: "url(#mask0_270_5359)" } }, [
        _c("path", {
          attrs: {
            d: "M12.7558 5.5C12.5436 5.5 12.3646 5.42854 12.2188 5.28563C12.0729 5.14271 12 4.96563 12 4.75438C12 4.54313 12.0718 4.36458 12.2154 4.21875C12.359 4.07292 12.5369 4 12.7492 4H17.2442C17.4564 4 17.6354 4.07146 17.7812 4.21437C17.9271 4.35729 18 4.53437 18 4.74562C18 4.95687 17.9282 5.13542 17.7846 5.28125C17.641 5.42708 17.4631 5.5 17.2508 5.5H12.7558ZM12.7558 8.75C12.5436 8.75 12.3646 8.67854 12.2188 8.53563C12.0729 8.39271 12 8.21563 12 8.00438C12 7.79313 12.0718 7.61458 12.2154 7.46875C12.359 7.32292 12.5369 7.25 12.7492 7.25H17.2442C17.4564 7.25 17.6354 7.32146 17.7812 7.46437C17.9271 7.60729 18 7.78437 18 7.99562C18 8.20687 17.9282 8.38542 17.7846 8.53125C17.641 8.67708 17.4631 8.75 17.2508 8.75H12.7558ZM12.7558 12C12.5436 12 12.3646 11.9285 12.2188 11.7856C12.0729 11.6427 12 11.4656 12 11.2544C12 11.0431 12.0718 10.8646 12.2154 10.7188C12.359 10.5729 12.5369 10.5 12.7492 10.5H17.2442C17.4564 10.5 17.6354 10.5715 17.7812 10.7144C17.9271 10.8573 18 11.0344 18 11.2456C18 11.4569 17.9282 11.6354 17.7846 11.7812C17.641 11.9271 17.4631 12 17.2508 12H12.7558ZM7 11C6.30556 11 5.71528 10.7569 5.22917 10.2708C4.74306 9.78472 4.5 9.19444 4.5 8.5C4.5 7.80556 4.74306 7.21528 5.22917 6.72917C5.71528 6.24306 6.30556 6 7 6C7.69444 6 8.28472 6.24306 8.77083 6.72917C9.25694 7.21528 9.5 7.80556 9.5 8.5C9.5 9.19444 9.25694 9.78472 8.77083 10.2708C8.28472 10.7569 7.69444 11 7 11ZM2 15.25V14.6875C2 14.2986 2.10069 13.9444 2.30208 13.625C2.50347 13.3056 2.77083 13.0625 3.10417 12.8958C3.70139 12.6042 4.32639 12.3819 4.97917 12.2292C5.63194 12.0764 6.30556 12 7 12C7.69444 12 8.36806 12.0764 9.02083 12.2292C9.67361 12.3819 10.2986 12.6042 10.8958 12.8958C11.2292 13.0625 11.4965 13.3056 11.6979 13.625C11.8993 13.9444 12 14.2986 12 14.6875V15.25C12 15.4625 11.9281 15.6406 11.7844 15.7844C11.6406 15.9281 11.4625 16 11.25 16H2.75C2.5375 16 2.35938 15.9281 2.21562 15.7844C2.07187 15.6406 2 15.4625 2 15.25Z",
            fill: "#1C1B1F",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }